import fetchWithTimeout from "./fetchAPI";

/***
 * Send feature to the server
 * @param {string} token
 * @param {Object} data
 * @returns {Object}}
 */
export async function modifyFeature(token, data) {
  const headers = new Headers();
  headers.append('Content-Type','application/json');
  headers.append('token',token);
  const response = await fetchWithTimeout(
    `feature`,
    {
      method: "PUT",
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
      headers,
      body: JSON.stringify(data),
    },
    3000
  );

  return response.json();
}

/***
 * Get features by client id
 * @param {string} token
 * @param {string} clientID
 * @returns {string}
 */
export async function getFeatures(token, clientId) {
  const headers = new Headers();
  headers.append('Content-Type','application/json');
  headers.append('token',token);
  const response = await fetchWithTimeout(
    `feature/getAll/${clientId}`,
    {
      method: "GET",
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
      headers
    },
    3000
  );

  return response.json();
}
